import React from 'react';
import { authRoles, PERMISSION } from 'app/auth';
import { MENU_ENUM } from 'app/main/role/constants';

const CreateDoctorConfig = {
  settings: {
    layout: {
      config: {},
    },
    nav: {
      title: 'Create Doctor',
    },
  },
  auth: authRoles.user,
  key: MENU_ENUM.DOCTOR,
  permission: PERMISSION.CREATE,
  routes: [
    {
      path: '/doctor/create',
      component: React.lazy(() => import('./CreateDoctor')),
    },
  ],
};

export default CreateDoctorConfig;
